import { render, staticRenderFns } from "./OtherCostListDetail.vue?vue&type=template&id=6c5f8f84&scoped=true"
import script from "./OtherCostListDetail.vue?vue&type=script&lang=js"
export * from "./OtherCostListDetail.vue?vue&type=script&lang=js"
import style0 from "./OtherCostListDetail.vue?vue&type=style&index=0&id=6c5f8f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5f8f84",
  null
  
)

export default component.exports